import {
  INCIDENT_ATTACHMENT_EXTENSIONS,
  toAcceptList,
} from '@/hooks/useUpload/fileTypeLists'

export const ALLOWED_FILE_EXTENSIONS = toAcceptList(
  INCIDENT_ATTACHMENT_EXTENSIONS
)

export const MAX_INCIDENT_FILES = 3

export const INCIDENT_CREATE_ANALYTICS = {
  incidentCreated: 'Incident Created',
  incidentRowPress: 'Button Press: Incident Row, Incidents View',
} as const
